// All the "25px" values below are in-place to ensure minimum spacing between
// elements and the edge of the page as the window is resized to be narrower.

import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@resources";
import papersImg from "@illustrations/papers-560x680.png";

interface ErrorPageLayoutProps {
    title: string;
    description: string | ReactNode;
    error: string;
    showLogo?: boolean;
    cta?: ReactNode;
}

const ErrorPageLayout = ({ title, description, error, showLogo = false, cta }: ErrorPageLayoutProps) => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col items-center h-screen">
            {showLogo ? (
                <div className="flex-1 flex items-end">
                    <div className="h-full pt-[25px] pb-[25px]" style={{ maxHeight: `calc(152px + 25px)`, minHeight: `calc(48px + 25px + 25px)` }}>
                        <button onClick={() => navigate(`/`)} className="cursor-pointer focus-visible:outline-focus-ring rounded" aria-label="Go to home page">
                            <Logo className="h-12 w-auto text-[#222933]" />
                        </button>
                    </div>
                </div>
            ) : (
                <div className="flex-1 w-full" style={{ minHeight: `25px` }} />
            )}
        <div className="flex flex-row w-full" style={{ maxWidth: `calc(585px + 25px)` }}>
            <div className="flex-1 mt-[35px] pl-[25px]" style={{ maxWidth: `calc(425px + 25px)` }}>
                <div className="flex flex-col items-center justify-center">
                    <h1 className="self-start text-[20px] leading-[24px] md:text-[28px] md:leading-[40px] font-medium text-neutral-950 tracking-[0.2px] md:tracking-[0.28px]">
                        {title}
                    </h1>
                    <div className="flex flex-col w-full mt-2">
                        <div className="w-full text-sm leading-5 tracking-[0.14px] text-neutral-800">
                            {typeof description === `string` ? (
                                <p>{description}</p>
                            ) : (
                                description
                            )}
                        </div>
                        {cta && <div className="w-full mt-4">{cta}</div>}
                        <p className="self-start font-mono text-xs text-[#ADBCCC] mt-4">{error}</p>
                    </div>
                </div>
            </div>
            <div
                className="w-[280px] h-[340px] -z-10 opacity-100 bg-cover bg-repeat-x -ml-[120px]"
                style={{ backgroundImage: `url(${papersImg})` }}
            />
        </div>
        <div className="flex-1 w-full" style={{ minHeight: `25px` }} />
    </div>
    );
};

export default ErrorPageLayout;
